import React, { useState } from 'react';
import { cn } from '../../utils/cn';

export interface TooltipProps {
  content: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export const Tooltip: React.FC<TooltipProps> = ({ content, children, className }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <span
      className="relative inline-flex items-center"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
      onFocus={() => setIsOpen(true)}
      onBlur={() => setIsOpen(false)}
    >
      {children}
      {isOpen && (
        <span
          role="tooltip"
          className={cn(
            'absolute bottom-[calc(100%+8px)] left-1/2 z-50 w-80 -translate-x-1/2 rounded-md border p-3 text-xs shadow-lg',
            className
          )}
          style={{
            backgroundColor: 'var(--color-background-paper)',
            borderColor: 'var(--color-border-light)',
            color: 'var(--color-text-primary)',
          }}
        >
          {content}
          <span
            className="absolute left-1/2 top-full h-2 w-2 -translate-x-1/2 rotate-45 border-r border-b"
            style={{
              backgroundColor: 'var(--color-background-paper)',
              borderColor: 'var(--color-border-light)',
            }}
          />
        </span>
      )}
    </span>
  );
};

